import script from "./IconLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./IconLoading.vue?vue&type=script&setup=true&lang=js"

import "./IconLoading.vue?vue&type=style&index=0&id=29c911d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c911d1"]])

export default __exports__